import { useQuery } from "hooks/useQuery";
import { getChartFetchEconomicData } from "../service";
import { getFRecessionProbabilitiesChartFilteredData } from "../utils";
import { getSectorLineColors } from "features/Strategy/utils";

export const useRecessionProbabilities = (period = "") => {
  const { isLoading, data } = useQuery({
    queryKey: ["recessionProbabilities", period],
    queryFn: async () => {
      const response = await getChartFetchEconomicData({
        name: "smoothedUSRecessionProbabilities",
        period,
      });

      const filteredData =
        getFRecessionProbabilitiesChartFilteredData(response);
      const lineColors = getSectorLineColors(filteredData);

      return {
        chartData: filteredData,
        chartLineColors: lineColors,
      };
    },
    enabled: true,
  });

  return {
    isLoading,
    chartData: data?.chartData || [],
    chartLineColors: data?.chartLineColors || [],
  };
};
